export const GoogleMapApiConfig = {
  key: "AIzaSyBDr4nadTBZ0Cmb6akOoHhepLsJ8l-8I5o",
};
